import { useEffect } from "react"

import { Flex, Form, Modal, Spin } from "antd"

import ButtonComponent from "../../../../Components/Button"
import InputComponent from "../../../../Components/Input"
import SelectComponent from "../../../../Components/Select"

const InviteUserModal = ({ open, onClose, editData, inviteRoles, saveFetching, onSubmit }) => {
  const [form] = Form.useForm()

  const isEdit = !!editData

  useEffect(() => {
    if (open) {
      form.setFieldsValue({
        name: editData?.admin_full_name || null,
        email: editData?.email || null,
        role: editData?.role || null
      })
    }
  }, [open, editData])

  const roleOptions = inviteRoles?.map((role) =>
    typeof role === "string"
      ? { value: role, label: role }
      : {
          value: role?.value ?? role?.id ?? role?.name,
          label: role?.label ?? role?.name ?? role?.value
        }
  )

  const onFinish = (values) => {
    onSubmit?.(values)
  }

  return (
    <Modal
      open={open}
      centered
      width={442}
      title={isEdit ? "Edit admin role" : "Invite admin user"}
      footer={null}
      closable
      onCancel={onClose}
      destroyOnClose
      classNames={{ content: "clear-bg" }}
    >
      <Spin size="large" spinning={!!saveFetching}>
        <Form
          form={form}
          layout="vertical"
          className="with-default-error"
          onFinish={onFinish}
          clearOnDestroy
        >
          {!isEdit && (
            <Form.Item
              label="Name"
              name="name"
              normalize={(value) => value?.trim() || ""}
              rules={[{ required: true, message: "Please insert admin's name" }]}
            >
              <InputComponent placeholder="e.g. John" />
            </Form.Item>
          )}

          <Form.Item
            label="Email Address"
            name="email"
            normalize={(value) => value?.trim() || ""}
            rules={[
              { required: true, message: "Please insert user's Email" },
              { type: "email", message: "The email you entered is incorrect" }
            ]}
          >
            <InputComponent placeholder="e.g. email@gmail.com" disabled={isEdit} />
          </Form.Item>

          <Form.Item
            label="Admin role"
            name="role"
            rules={[{ required: true, message: "Please select admin role" }]}
          >
            <SelectComponent size="large" placeholder="Select admin role" options={roleOptions} />
          </Form.Item>

          <Flex gap={16} justify="end" style={{ padding: "24px 3px 3px 3px" }}>
            <ButtonComponent size="large" htmlType="button" onClick={onClose}>
              Cancel
            </ButtonComponent>

            <ButtonComponent size="large" type="primary" htmlType="submit">
              {isEdit ? "Save" : "Send Invite"}
            </ButtonComponent>
          </Flex>
        </Form>
      </Spin>
    </Modal>
  )
}

export default InviteUserModal
